import ProfileForm from 'features/components/ProfileForm/ProfileForm.component'

const Profile = () => {
  return <ProfileForm />
}

export default Profile
